
import { SceneControl } from '@anov/3d-core'
import {ISkyController, SkyMode, SkyOptions} from '../types'
import { DynamicWeatherSystem } from '../DynamicWeatherSystem'

export class SkyController implements ISkyController{
    readonly mode: SkyMode  = 'sky'
    object: DynamicWeatherSystem
    private sceneControl: SceneControl

    constructor(options?: SkyOptions, sceneControl?: SceneControl) {
        this.sceneControl = sceneControl
        this.object = new DynamicWeatherSystem(sceneControl)
        this.update(options)
    }

    get time() {
        return this.object.time
    }
    get weather() {
        return this.object.weather
    }

    enter() {
        this.object.visible = true
    }

    exit() {
        this.object.visible = false
    }
    update(options: SkyOptions) {
        if (options?.time) this.object.setTime(options.time)
        if (options?.weather) this.object.setWeather(options.weather)
    }
    setTime(time: string) {
        this.object.setTime(`${time}:00`)
    }
    setWeather(weather: string) {
        this.object.setWeather(weather)
    }
}